import { Column, Spinner, Row, Text } from "@hightouch/htui";

import type { ChartConfig, ChartResult, LabelResolver } from "./types";
import { ChartCard } from "./chart-card";

interface ChartListProps {
  configs: ChartConfig[];
  chartResultsById: Map<string, ChartResult>;
  isComputing: boolean;
  onDelete: (chartId: string) => Promise<void>;
  onRename: (chartId: string, name: string) => Promise<void>;
  deletingChartId: string | null;
  resolveLabel: LabelResolver;
  hasCampaignId: boolean;
  flowName: string;
}

export function ChartList({
  configs,
  chartResultsById,
  isComputing,
  onDelete,
  onRename,
  deletingChartId,
  resolveLabel,
  hasCampaignId,
  flowName,
}: ChartListProps) {
  if (configs.length === 0 && !isComputing) {
    return (
      <Row justify="center" py={12}>
        <Text color="text.secondary">
          No charts configured. Add a chart to get started.
        </Text>
      </Row>
    );
  }

  if (configs.length === 0 && isComputing) {
    return (
      <Row justify="center" py={12}>
        <Spinner size="lg" />
      </Row>
    );
  }

  return (
    <Column gap={6}>
      {configs.map((config) => (
        <ChartCard
          key={config.id}
          config={config}
          result={chartResultsById.get(config.id)}
          isComputing={isComputing}
          onDelete={() => onDelete(config.id)}
          onRename={(name) => onRename(config.id, name)}
          isDeleting={deletingChartId === config.id}
          resolveLabel={resolveLabel}
          hasCampaignId={hasCampaignId}
          flowName={flowName}
        />
      ))}
    </Column>
  );
}
